import { ReadItemsStatusAction, ReadItemsStatusActionKeys } from './actions';
import Utils from '../../utils';

interface ReadItemsListState {
	items: { [k: number]: ReadItemState };
}

interface ReadItemState {
	lastVersionRead: number;
}

const driveItemReadInitialState: ReadItemState = {
	lastVersionRead: 0
};

const initialState: ReadItemsListState = {
	items: {}
};

function readStatus(state: ReadItemsListState = initialState, action: ReadItemsStatusAction): ReadItemsListState {

	let newState = Utils.deepCopy(state);
	let item: ReadItemState;
	switch (action.type) {
		case ReadItemsStatusActionKeys.INIT_READ_STATUS_STORE:
			action.storedReadItems.forEach(item => newState.items[item.id] = {
				lastVersionRead: item.lastVersionRead
			});
			return newState;
		case ReadItemsStatusActionKeys.REMOVE_ITEM:
			delete newState.items[action.id];
			return newState;
		case ReadItemsStatusActionKeys.UPDATE_READ_STATUS:
			item = getItemFromMap(newState.items, action.id);
			item.lastVersionRead = action.version;
			newState.items[action.id] = item;
			return newState;
		default:
			return state;
	}
}

function getItemFromMap(items: { [k: number]: ReadItemState }, itemId: number): ReadItemState {
	return items[itemId] ? items[itemId] : Utils.deepCopy(driveItemReadInitialState);
}

export { readStatus, ReadItemsListState, ReadItemState };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ReadStatus/reducer.ts